module.exports = __webpack_public_path__ + "assets/img/18_1846_big.6b3967da.jpg";